import { defineMessages } from 'react-intl';

/** The Notifications tab, grouped by product (design settings-redesign c1-c6). */
export const notificationsMessages = defineMessages({
  subtitle: {
    id: 'app.sml.settings.notifications.subtitle',
    defaultMessage: 'The emails we send you, grouped by the part of MUSIC24 they come from.',
  },
  recipient: {
    id: 'app.sml.settings.notifications.recipient',
    defaultMessage: 'Emails go to {email}. Each workspace you belong to sends its own, with its name in the subject.',
  },
  publicDescription: {
    id: 'app.sml.settings.notifications.group.public.description',
    defaultMessage: 'Your watchlist: what you follow in Trends, Artists, Tracks, Playlists, Markets and Browse',
  },
  yoursDescription: {
    id: 'app.sml.settings.notifications.group.yours.description',
    defaultMessage: 'Catalog, Insights and Promote performance',
  },
  yoursNone: {
    id: 'app.sml.settings.notifications.group.yours.none',
    defaultMessage: 'These pages send no email yet. Open them in the app to see your numbers.',
  },
  promoteDescription: {
    id: 'app.sml.settings.notifications.group.promote.descriptionConnections',
    defaultMessage: 'SmartLinks, Releases, Composer, Calendar, Studio and Connections',
  },
  // The native apps read the old Channels copy (navigation v2 renamed the page Connections).
  promoteDescriptionNative: {
    id: 'app.sml.settings.notifications.group.promote.description',
    defaultMessage: 'SmartLinks, Releases, Composer, Calendar, Studio and Channels',
  },
  accountTitle: { id: 'app.sml.settings.notifications.group.account.title', defaultMessage: 'Account and plan' },
  digestDescription: {
    id: 'app.sml.settings.notifications.digest.description',
    defaultMessage: 'A summary of the artists, tracks and playlists you follow.',
  },
  dailyOnFree: {
    id: 'app.sml.settings.notifications.digest.dailyOnFree',
    defaultMessage: 'You chose Daily. Free sends it weekly, every Monday, until you upgrade.',
  },
  threshold: { id: 'app.sml.settings.notifications.alerts.threshold', defaultMessage: 'Threshold' },
  playlistDescription: {
    id: 'app.sml.settings.notifications.playlistAlerts.description',
    defaultMessage: 'One email the day a playlist adds a track you follow.',
  },
  playlistFloor: {
    id: 'app.sml.settings.notifications.playlistAlerts.floor',
    defaultMessage: 'Playlists with at least',
  },
  publicFooter: {
    id: 'app.sml.settings.notifications.group.public.footer',
    defaultMessage: 'Alerts and digests read the follows of each workspace.',
  },
  howItWorks: {
    id: 'app.sml.settings.notifications.howItWorks',
    defaultMessage: 'How digests and alerts work',
  },
  freeNote: {
    id: 'app.sml.settings.notifications.freeNote',
    defaultMessage: 'Free sends the weekly digest. Daily digests and alerts start with the Plus plan.',
  },
  presaveTitle: { id: 'app.sml.settings.notifications.presave.title', defaultMessage: 'Pre-save reminders' },
  presaveDescription: {
    id: 'app.sml.settings.notifications.presave.description',
    defaultMessage: 'A note when a release date passes and the pre-save page has no links yet.',
  },
  alwaysOn: { id: 'app.sml.settings.notifications.alwaysOn', defaultMessage: 'Always on' },
  alwaysSent: {
    id: 'app.sml.settings.notifications.alwaysSent',
    defaultMessage: 'Always sent: sign-in codes, email change codes, team invites and billing receipts.',
  },
});
